module.exports = __webpack_public_path__ + "static/media/icon-print.af67134d.svg";